import * as yup from 'yup';
import { TFunction } from 'i18next';
import { SubmissionResponseDtoStatusEnum } from 'libs/pinnacle-sdk';
import { CloseSubmissionValues } from './types';

export const getValidationSchema = (t: TFunction) =>
  yup.object().shape({
    status: yup
      .string()
      .oneOf(Object.values(SubmissionResponseDtoStatusEnum))
      .required(t('validation.required', { field: t('general.status') })),
    competitorRateOnLine: yup
      .number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .min(
        0,
        t('validation.min', {
          field: t('closeSubmissionModal.competitorRateOnLine'),
          min: 0,
        })
      )
      .max(
        100,
        t('validation.max', {
          field: t('closeSubmissionModal.competitorRateOnLine'),
          max: 100,
        })
      )
      .nullable(),
    competitorRateOnExposure: yup
      .number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .min(
        0,
        t('validation.min', {
          field: t('closeSubmissionModal.competitorRateOnExposure'),
          min: 0,
        })
      )
      .max(
        100,
        t('validation.max', {
          field: t('closeSubmissionModal.competitorRateOnExposure'),
          max: 100,
        })
      )
      .nullable(),
    reason: yup.string().nullable(),
  });

export const initialValues: CloseSubmissionValues = {
  status: SubmissionResponseDtoStatusEnum.Declined,
  competitorRateOnLine: undefined,
  competitorRateOnExposure: undefined,
  reason: undefined,
};
